/// Appelé uniquement sur la page de coordonnees des listes mariages, pacs et cadeaux
/// /liste-cadeaux/creation/confirmation/[IDList]
class Confirmation extends ListeMariage {
	/// Il s'agit de la fonction appelée sur chacune des pages du tunnel
	initialize() {
		let self = this;

		super.initialize();
	}
}